import DateRangePicker, { useUrlDateRange } from "./DateRangePicker";

/**
 * The report period on the Ads and Facebook pages: presets (7, 30, 90 days, this
 * or last week, month to date, last month) or custom dates, kept in the URL so a
 * view can be shared. The page reads it back with reportRangeQuery (date-range.ts).
 */
export function AdsRange() {
  const [range, setRange] = useUrlDateRange();
  return <DateRangePicker value={range} onChange={setRange} label="Report period" />;
}
